import { useState } from 'react';

import Button from '@mui/material/Button';

import { formatProviderName } from '../../helpers/providers';
import {getServiceCategories} from '../../helpers/selectOptions';
import {parseErrorFromResponse} from '../../helpers/errors';
import {useCreateSessionMutation} from '../../redux/services/sessionApi';
import getServiceIcon from './getServiceIcon';
import Form from '../common/Form';
import CustomDialog from '../common/CustomDialog';
import SchedulerInput from './SchedulerInput';

const sections = [
  {name: 'basic', label: 'Service Type'},
  {name: 'scheduling', label: 'Scheduling'},
];

const fields = ({
  providerId, 
  serviceCategory, 
  setServiceCategory
}) => [
  {
    section: 'basic',
    name: 'service_category',
    // label: 'Service Category',
    type: 'choice',
    options: getServiceCategories().map(cat => ({
      label: cat.label,
      value: cat.value,
      description: cat.description,
      color: cat.colorName,
      xs: 12,
      md: 4,
      lg: 4,
      xl: 3,
      Icon: getServiceIcon({service: cat.value}),
    })),
    onChange: (e, val) => {
      setServiceCategory(val);
    }
  },
  {
    section: 'scheduling',
    label: null,
    name: 'scheduling',
    type: 'custom',
    providerId,
    allowOverrideSchedule: false,
    color: 'purple',
    serviceCategory,
    isPatient: true,
    Component: SchedulerInput,
  },
];

const serializer = () => (data) => {
  const {scheduling} = data;
  return {
    service_category: data.service_category,
    location_type: scheduling.location_type,
    start_time: scheduling.start_time,
    provider_availability_id: scheduling.provider_availability_id,
  }
};

const handleSubmit = ({post, onClose, providerId}) => async (formData) => {
  const payload = {
    provider_id: providerId,
    ...formData,
  };
  const response = await post({body: payload});
  if (response.data) {
    onClose();
  }
};

const ScheduleWithProviderButton = ({
  provider,
  day,
  onTimeSelect,
  ButtonComponent = Button,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [serviceCategory, setServiceCategory] = useState(props?.serviceCategory);
  const [post, response] = useCreateSessionMutation();
  const error = parseErrorFromResponse(response);
  const onSubmit = handleSubmit({
    post, 
    onClose: () => setIsOpen(false),
    providerId: provider.id,
  });
  return [
    <ButtonComponent
      key='button'
      variant={variant}
      color={color}
      size={size}
      onClick={e => {
        e.stopPropagation();
        setIsOpen(true)
      }}
    >
      Schedule
    </ButtonComponent>,
    <CustomDialog
      key='dialog'
      title={`Book with ${formatProviderName(provider)}`}
      open={isOpen}
      onClose={() => setIsOpen(false)}
      error={error}
    >
      <Form
        key={`form-${provider.id}`}
        sections={sections}
        fields={fields({
          providerId: provider.id, 
          serviceCategory,
          setServiceCategory,
        })}
        defaultValues={{
          service_category: props?.serviceCategory,
        }}
        serializer={serializer()}
        onSubmit={(data) => onSubmit(data)}
      />
    </CustomDialog>
  ];
}

export default ScheduleWithProviderButton;